import { API_BASE_URL } from "../../constants"
import axios from "../axios"

export default function createResetPasswordRequest(email: string) {
  return axios
    .post(`${API_BASE_URL}/reset-password-requests`, { email })
    .then((response) => response.data)
}
